"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAxesHelper = void 0;
const three_1 = require("three");
function createAxesHelper(webgl, size) {
    const axesHelper = new three_1.AxesHelper(size);
    axesHelper.visible = false;
    webgl.addObject(axesHelper);
    return axesHelper;
}
exports.createAxesHelper = createAxesHelper;
